import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Facebook: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                d="M11.4285714,5.2 L9.10769231,5.2 L9.10769231,3.54285714 C9.10769231,2.91428571 9.47692308,2.8 9.74065934,2.8 C10.0043956,2.8 11.3758242,2.8 11.3758242,2.8 L11.3758242,0 L9.10769231,0 C6.57582418,0 5.9956044,2.05714286 5.9956044,3.37142857 L5.9956044,5.2 L4.57142857,5.2 L4.57142857,8 L6.04835165,8 C6.04835165,11.6 6.04835165,16 6.04835165,16 L9.10769231,16 C9.10769231,16 9.10769231,11.6 9.10769231,8 L11.1648352,8 L11.4285714,5.2 Z"
                fill="currentColor"
                fillRule="nonzero"
            ></path>
        </Icon>
    );
};
